var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailToFax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFEFF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 14h19.2c1.32 0 2.4 1.113 2.4 2.5v15c0 1.375-1.08 2.5-2.4 2.5H14.4c-1.32 0-2.4-1.125-2.4-2.5v-15c0-1.387 1.068-2.5 2.4-2.5zm16.8 17.5h2.4v-15h-1.44L24 21.813 15.84 16.5H14.4v15h2.4V20.562L24 25.25l7.2-4.688V31.5z",
    fill: "#FF5C6E"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNGRkVGRjEiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC40IDE0SDMzLjZDMzQuOTIgMTQgMzYgMTUuMTEyNSAzNiAxNi41VjMxLjVDMzYgMzIuODc1IDM0LjkyIDM0IDMzLjYgMzRIMTQuNEMxMy4wOCAzNCAxMiAzMi44NzUgMTIgMzEuNVYxNi41QzEyIDE1LjExMjUgMTMuMDY4IDE0IDE0LjQgMTRaTTMxLjIwMDQgMzEuNUgzMy42MDA0VjE2LjVIMzIuMTYwNEwyNC4wMDA0IDIxLjgxMjVMMTUuODQwNCAxNi41SDE0LjQwMDRWMzEuNUgxNi44MDA0VjIwLjU2MjVMMjQuMDAwNCAyNS4yNUwzMS4yMDA0IDIwLjU2MjVWMzEuNVoiIGZpbGw9IiNGRjVDNkUiLz4KPC9zdmc+Cg==";
export { SvgEmailToFax as ReactComponent };